import React from 'react';
import del from '../Res/Icon/delete.png';
import edit from '../Res/Icon/edit.png';
import recover from '../Res/Icon/recover.png';
import { getPermissionForComponent } from '../utils/permissionsUtils';
const CompanyGroups = ({ company, disabled, onDelete, onEdit, deleteMode, onRecover,user }) => {
  const DeleteCompanyGroup = getPermissionForComponent('deleteCompanyGroup', user.permissionsGroup);

  const { _id: id, name, managedCompanies, groupSuperAdmins, groupManagers } = company;
  return (
    <tr>
      {/* <td>{id}</td> */}
      <td>{name}</td>
      <td>{company?.company?.name}</td>
      <td>{(groupSuperAdmins?.length || 0) + (groupManagers?.length || 0)}</td>
      <td>{company?.managedDevices || 0}</td>
      <td>{company?.monitoredDevices || 0}</td>
      <td>{managedCompanies?.length}</td>
      <td style={{ minWidth: '100px' }}>
        {!deleteMode ? (
          <img onClick={() => onEdit(company)} className="actions-icon" src={edit} alt="edit" />
        ) : (
          <img onClick={() => onRecover(id)} className="actions-icon" src={recover} alt="recover" />
        )}
        {(DeleteCompanyGroup === 'write' || DeleteCompanyGroup === 'both' || user.role === 'superAdmin') && (
          <img
            onClick={() => onDelete(id)}
            className="actions-icon"
            src={del}
            alt="delete"
          />
        )}
      </td>
    </tr>
  );
};

export default CompanyGroups;
